import { throwApiError } from '@/shared/utils/apiResponse';
import { apiGet } from '@/shared/utils/requestBuilder';

import type { ChatAuditListResult, FetchConversaAuditoriaParams } from '../../types';
import { OPERACOES_PERTINENTES } from '../../utils/auditoriaLabels';

const unwrap = <T>(body: unknown): T => {
  if (typeof body === 'object' && body !== null && 'data' in body) {
    return (body as { data: T }).data;
  }
  return body as T;
};

const jsonOk = async <T>(response: Response, fallbackMsg: string): Promise<T> => {
  if (!response.ok) await throwApiError(response, fallbackMsg);
  const body = (await response.json()) as unknown;
  return unwrap<T>(body);
};

export const auditoriaService = {
  getConversaAuditoria: async (
    params: FetchConversaAuditoriaParams,
  ): Promise<ChatAuditListResult> => {
    const query: Record<string, string | number> = {
      limit: params.limit ?? 50,
      operacao: OPERACOES_PERTINENTES.join(','),
    };
    if (params.cursor) query.cursor = params.cursor;

    const response = await apiGet(
      `/admin/chat/conversas/${encodeURIComponent(params.conversaId)}/auditoria`,
      query,
    );
    return jsonOk<ChatAuditListResult>(response, 'Erro ao carregar auditoria da conversa');
  },
};
